import sodium from "libsodium-wrappers-sumo";

let ready: Promise<typeof sodium> | null = null;

function load(): Promise<typeof sodium> {
  if (!ready) ready = sodium.ready.then(() => sodium);
  return ready;
}

// Seal a UTF-8 plaintext against the machine's X25519 public key and return the
// standard-base64 ciphertext ready to POST to /encrypted-secrets. Format is
// identical to libsodium's crypto_box_seal — the local agent decrypts it via
// @sage-mcp/shared's decryptForMachine.
export async function sealBase64(publicKeyBase64: string, plaintext: string): Promise<string> {
  const s = await load();
  const publicKey = s.from_base64(publicKeyBase64, s.base64_variants.ORIGINAL);
  const message = new TextEncoder().encode(plaintext);
  const ciphertext = s.crypto_box_seal(message, publicKey);
  return s.to_base64(ciphertext, s.base64_variants.ORIGINAL);
}

export async function readyPromise(): Promise<void> {
  await load();
}
